import { ErEmploymentStatus, ErSeniorityLevel, Language } from "./other";
import { Base } from "./base";
import { ErEvent } from "./event";
import { ErCity, ErCounty, ErState, ErZipcode } from './facility';
import { ErImage } from "./image";
import { ErCMSpecialty } from "./caremanager";

export class CareGiver extends Base {
  EoOrganizationId: number;
  Name: string;
  EmailAddress: string;
  PhoneNumber: string;
  HourlyPrice: number;
  YearsExperience: number;
  SeniorityLevel: ErSeniorityLevel;
  EmploymentStatus: ErEmploymentStatus;
  DescSummary: string;
  DescExperience: string;
  DescCompensation: string;
  ErImageId: number;
  ImageGuid: string;
  ReviewsAverage: number;

  // address of caregiver
  Address: string;
  ZipCodeStr: string;
  Zipcode: ErZipcode;
  BizCity: ErCity;
  BizCounty: ErCounty;
  BizState: ErState;

  Cities: ErCity[];
  City: ErCity;
  County: ErCounty;
  State: ErState;
  BizZipcode: ErZipcode;

  ShowBizAddress: boolean;
  Website: string;

  Languages: Language[];
  Events: ErEvent[];
  Reviews: ErCaregiverReview[];
  CMSpecialties: ErCMSpecialty[];

  // For display
  CityNames: string;
}

export class ErCaregiverReview extends Base {

  constructor(obj: ErCaregiverReview = null) {
    super(obj);
    if (!obj) return;
    if (obj.Image)
      obj.Image = new ErImage(obj.Image)
  }

  PublishedAt: Date;
  PublishedBy: string;
  Stars: number;
  Description: string;

  // Avatar
  Image: ErImage;
}
